<template>
  <div class="d-flex justify-content-center p-4 align-middle" >
      <b-spinner variant="primary" label="Loading..."></b-spinner>
    </div>
</template>

<script>
export default {
  name: 'LoadingSpinner'
}
</script>

<style>

</style>
